"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useESignProcessBase = exports.DOC_UPLOADED_ERROR = exports.DOC_UPLOADED_SUCCESSFUL = void 0;
const useBeginESignProcessService_hook_1 = require("./useBeginESignProcessService.hook");
const useFinishESignProcessService_hook_1 = require("./useFinishESignProcessService.hook");
const initializer_1 = require("../../initializer");
const webSocket_1 = require("../helpers/requestHelpers/webSocket");
exports.DOC_UPLOADED_SUCCESSFUL = 'COMPLETED';
exports.DOC_UPLOADED_ERROR = 'ERROR';
const ERROR_STATUS = 400;
const useESignProcessBase = (repository) => {
    const { beginESignProcessCall, isBeginESignProcessLoading, isBeginESignProcessSuccess, beginESignProcessData, isBeginESignProcessError } = (0, useBeginESignProcessService_hook_1.useBeginESignProcessService)(repository);
    const { finishESignProcessCall, isFinishESignProcessLoading, isFinishESignProcessSuccess, isFinishESignProcessError } = (0, useFinishESignProcessService_hook_1.useFinishESignProcessService)(repository);
    const transformWSResponse = (data) => {
        const parsedData = JSON.parse(data);
        if (parsedData.statusCode >= ERROR_STATUS) {
            return exports.DOC_UPLOADED_ERROR;
        }
        return parsedData.detail.payload.operationProcessStatus;
    };
    const getSignedDocUploadStatus = (operationProcessId, handleResponse, handleError) => {
        const accessToken = initializer_1.Session.getData()?.accessToken;
        if (accessToken) {
            const instance = new webSocket_1.WebSocket(accessToken, {
                service: 'mb-api-terms-n-conds',
                eventType: 'docStatusReady',
                endpoint: '/v1/document/websocket',
                detail: {
                    headers: {
                        accessToken,
                    },
                    payload: {
                        operationProcessId,
                    },
                },
            }, handleResponse, handleError, undefined, transformWSResponse);
            return instance;
        }
    };
    return {
        beginESignProcessCall,
        isBeginESignProcessLoading,
        isBeginESignProcessSuccess,
        beginESignProcessData,
        isBeginESignProcessError,
        getSignedDocUploadStatus,
        finishESignProcessCall,
        isFinishESignProcessLoading,
        isFinishESignProcessSuccess,
        isFinishESignProcessError,
    };
};
exports.useESignProcessBase = useESignProcessBase;
//# sourceMappingURL=useESignProcessBase.hook.js.map